module.exports = __webpack_public_path__ + "static/media/icon_PDF_W.b823e151.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_PDF_W.svg
// module id = 1938
// module chunks = 0